<template>
  <div :class="viewer ? '' : 'page'">
    <div v-if="!viewer">
      <div v-if="getMode() == 'new'" class="feature-intro">
        <h1>Nuevo {{ pageName }}</h1>
        <p>Ingrese los datos del formulario</p>
      </div>
      <div v-else class="feature-intro">
        <h1>Editando {{ pageName }}</h1>
        <p>Modifique los datos que desea EDITAR</p>
      </div>
    </div>

    <div class="mb-4 text-xl">UFI Seleccionada</div>

    <TForm
      :data="data"
      :nombres="names"
      :errors="errors"
      :mensajes="mensajes"
      :mode="getMode()"
      :designEdit="designEdit"
      :designNew="design"
      :url="url"
      :viewer="viewer"
      :viewerID="viewerID"
    />
  </div>
</template>

<script>
export default {
  props: {
    viewer: {
      type: Boolean,
    },
    viewerID: {
      type: String,
    },
  },
  data() {
    return {
      data: {
        Nombre: {
          value: "nicolas",
          value2: "gonzalo",
          validation: "required|max_length[50]",
          type: "input",
        },
        Descripcion: {
          value: "2645064965",
          value2: "2645064969",
          validation: "max_length[50]",
          type: "input",
        },
      },
      names: {
        Nombre: "",
        Descripcion: "",
      },
      errors: {
        Nombre: false,
        Descripcion: false,
      },
      mensajes: {
        Nombre: "",
        Descripcion: "",
      },
      design: [["Nombre", "Descripcion"]],
      designEdit: [["Nombre", "Descripcion"]],
      id: "",
      url: process.env.VUE_APP_BACKEND_ENVIRONMENT + "/categoria-ufi",
      pageName: "UFIs",
    };
  },
  created() {
    let { id } = this.$route.params;
    this.id = id;
  },
  methods: {
    getMode() {
      return this.id == "add" ? "new" : "edit";
    },
  },
};
</script>
